<template>
  <span class="text-danger" :class="textClass"> {{ text }}</span>
</template>

<script setup lang="ts">
import { withDefaults, defineProps } from "vue";

type RequiredWarningTextProps = {
  text: string;
  textClass?: string;
};

withDefaults(defineProps<RequiredWarningTextProps>(), {
  text: "This field is mandatory",
  textClass: "text-tiny",
});
</script>

<style scoped></style>
